const appRoutes = {
  login: "/login",
  forgotPassword: "/recover",
  resetPassword: "/reset-password",
  createPassword: "/create-password",
  supportChat: "/app/SupportChat",
  viewTickets: "/app/Ticket/ViewTickets",
  generateTicket: "/app/Ticket/GenerateTicket",
  editTicket: "/app/Ticket/EditTicket",
  receivedResults: "/app/Ticket/ReceivedResults",
  viewBookings: "/app/Booking/ViewBooking",
  editBooking: "/app/Booking/EditBooking",
  generateBooking: "/app/Booking/GenerateBooking",
  loginsSupportStaff: "/app/Logins",
  appSettings: "/app/AppSettings",
  patientsInQueue: "/app/Patients/PatientsQueue",
  // bookings: "/app/Patients/Bookings",
  consultRequests: "/app/Patients/ConsultRequests",
  patients: "/app/Patient",
  doctorsInQueue: "/app/DoctorQueue",
  doctorNewApplications: "/app/Doctors/NewApplications",
  doctorApproved: "/app/Doctors/Approved",
  doctorRejected: "/app/Doctors/Rejected",
  nursesInQueue: "/app/NursesQueue",
  nurseNewApplications: "/app/Nurses/NewApplications",
  nurseApproved: "/app/Nurses/Approved",
  nurseRejected: "/app/Nurses/Rejected",
  pharmacies: "/app/Pharmacies",
  natureOfConsult: "/app/NatureofConsult",
  consultCosts: "/app/ConsultCosts",
  consultCostsMedicare: "/app/ConsultCostsMedicare",
  pastConsults: "/app/ConsultHistory/PastConsults",
  unansweredConsultRequests: "/app/ConsultHistory/UnansweredConsults",
  appointmentCounts: "/app/ConsultHistory/appointment/count",
  faqs: "/app/FAQs",
  viewLegal: "/app/Legal",
  editLegal: "/app/EditLegal",
  changePassword: "/app/change-password",
  changePin: "/app/change-pin",
  drugDatabase: "/app/DrugDatabase",
  blockedDrugs: "/app/BlockedDrugs",
  viewCouponsList: "/app/viewCoupons",
  viewCouponDetail: "/app/viewCouponDetails",
  viewForum: "/app/forum",
  createForumPost: "/app/createPost",
  forumPostDetails: "/app/forumPostDetails",
  marketing: "/app/promotions",
  consultCostsInstantSwitch: "/app/consult-cost/instant-switch",
  consultCostsInstantHush: "/app/consult-cost/instant-hush",
  consultCostsMedicinalCannabis: "/app/consult-cost/medicinal-cannabis",
  instantSwitchConsultCostMedicare: "/app/consult-cost/instant-switch/medicare",
  instantSwitchOnlineAssessments: "/app/instant-switch/OnlineAssessments",
  // smokingCessationDoctorSchedule: "/app/instant-switch/smokingCessationDoctorSchedule",
  // medicinalCannabisDoctorSchedule: "/app/instant-switch/medicinalCannabisDoctorSchedule",
  instantExtraDoctorSchedule: "/app/instant-extras/doctorSchedule",
  instantExtraAssessments: "/app/instant-extras/assessments",
  instantSwitchOnlineAssessmentsDetails: "/app/instant-switch/OnlineAssessments/Details",
  medicinalCannabisOnlineAssessments: "/app/medicinal-cannabis/OnlineAssessments",
  medicinalCannabisOnlineAssessmentsDetails: "/app/medicinal-cannabis/OnlineAssessments/Details",
  instantHushOnlineAssessments: "/app/instant-hush/OnlineAssessments",
  instantHushOnlineAssessmentsDetails: "/app/instant-hush/OnlineAssessments/Details",
  traditionalPrescriptionList: "/app/prescription/traditional"
  // logFile: "/app/log-file",
  // securitySetting: "/app/security-setting"
};

export default appRoutes;
